import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaUserCog, FaBell, FaLock } from 'react-icons/fa';
import './UniversityHome.css'; // Reuse existing styles for consistency

const UniversitySettings = () => {
  const navigate = useNavigate();
  const [settings, setSettings] = useState({
    emailNotifications: true,
    smsNotifications: false,
    profileVisibility: 'public',
  });

  const handleToggle = (key) => {
    setSettings((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSelect = (e) => {
    setSettings((prev) => ({ ...prev, profileVisibility: e.target.value }));
  };

  return (
    <div className="university-home">
      <header className="university-header">
        <div className="university-header-content">
          <button className="btn-secondary" onClick={() => navigate('/university-home')} style={{marginRight: 16}}>
            <FaArrowLeft /> Back
          </button>
          <h1 style={{margin: 0}}>University Settings</h1>
        </div>
      </header>
      <main className="university-main">
        <div className="university-main-container">
          <section className="university-programs-section">
            <div className="university-section-header">
              <h3>Settings</h3>
              <p>Manage your university account preferences</p>
            </div>
            <div className="settings-grid">
              <div className="settings-card">
                <div className="university-settings-icon"><FaUserCog /></div>
                <h4>Profile Visibility</h4>
                <select value={settings.profileVisibility} onChange={handleSelect} className="settings-select">
                  <option value="public">Public</option>
                  <option value="private">Private</option>
                  <option value="university">University Only</option>
                </select>
              </div>
              <div className="settings-card">
                <div className="university-settings-icon"><FaBell /></div>
                <h4>Email Notifications</h4>
                <label className="switch">
                  <input type="checkbox" checked={settings.emailNotifications} onChange={() => handleToggle('emailNotifications')} />
                  <span className="slider round"></span>
                </label>
                <span style={{marginLeft: 8}}>{settings.emailNotifications ? 'Enabled' : 'Disabled'}</span>
              </div>
              <div className="settings-card">
                <div className="university-settings-icon"><FaLock /></div>
                <h4>SMS Notifications</h4>
                <label className="switch">
                  <input type="checkbox" checked={settings.smsNotifications} onChange={() => handleToggle('smsNotifications')} />
                  <span className="slider round"></span>
                </label>
                <span style={{marginLeft: 8}}>{settings.smsNotifications ? 'Enabled' : 'Disabled'}</span>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default UniversitySettings; 